const { signIn, signUp, logout, getAccount, updateAccount, changePassword, forgotPassword, resetPassword } = require('@/controllers/users').ct_users;

const state = {
    user_logged: false,
    access_token: null,
    refresh_token: null,
    account: null,
};

const mutations = {
    SET_SESSION(state, { access_token, refresh_token = null, account }) {
        state.user_logged = true;
        state.access_token = access_token;
        state.refresh_token = refresh_token;
        state.account = account;
    },
    SET_TOKENS(state, { access_token, refresh_token }) {
        state.access_token = access_token;
        if (refresh_token) state.refresh_token = refresh_token;
    },
    SET_ACCOUNT(state, account) {
        state.account = account;
    },
    ERASE_SESSION(state) {
        state.user_logged = false;
        state.access_token = null;
        state.refresh_token = null;
        state.account = null;
    },
};

const getters = {
    get_user_data(state) {
        return state;
    },
    get_company_name(state) {
        return state.account?.company?.company_name || '';
    },
    get_role(state) {
        return state.account?.role || '';
    },
};

const actions = {
    async login({ commit, dispatch }, payload) {
        const { email, password, keepLogged = false } = payload;

        if (!email || !password) {
            throw "Precisa fornecer um e-mail e uma senha";
        }

        const response = await signIn({ email, password, keepLogged });

        if (!response.status) {
            throw response.error;
        }

        commit('SET_SESSION', {
            access_token: response.access_token,
            refresh_token: response.refresh_token,
            account: response.data,
        });

        await dispatch('meta/load_options', null, { root: true });
    },

    // o signup já devolve os tokens (loga direto)
    async register({ commit, dispatch }, payload) {
        const response = await signUp({
            ...payload,
            whatsapp: payload.whatsapp ? payload.whatsapp.replace(/\D/g, '') : undefined,
        });

        if (!response.status) {
            throw response.error;
        }

        commit('SET_SESSION', {
            access_token: response.access_token,
            refresh_token: response.refresh_token,
            account: response.data,
        });

        await dispatch('meta/load_options', null, { root: true });

        return response;
    },

    async logout({ commit }) {
        try {
            await logout();
        } finally {
            commit('ERASE_SESSION');
            // limpa tudo o que é da empresa anterior
            [
                'meta/RESET_META_STATE',
                'materials/RESET_MATERIALS_STATE',
                'contacts/RESET_CONTACTS_STATE',
                'transactions/RESET_TRANSACTIONS_STATE',
                'expenses/RESET_EXPENSES_STATE',
                'reports/RESET_REPORTS_STATE',
            ].forEach((mutation) => commit(mutation, null, { root: true }));
        }
    },

    // valida a sessão e atualiza os dados da conta
    async refresh_account({ state, commit }) {
        const response = await getAccount(state.access_token);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_ACCOUNT', response.data);
        return response.data;
    },

    async update_account({ commit }, payload) {
        const response = await updateAccount(payload);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_ACCOUNT', response.data);
        return response;
    },

    async change_password(_, payload) {
        const response = await changePassword(payload);

        if (!response.status) {
            throw response.error;
        }

        return response;
    },

    async recovery_password(_, payload) {
        if (!payload.email) {
            throw "Informe o e-mail cadastrado";
        }

        const response = await forgotPassword(payload);

        if (!response.status) {
            throw response.error;
        }

        return response;
    },

    async reset_password(_, payload) {
        if (!payload.token || !payload.password) {
            throw "Link inválido ou expirado. Peça um novo.";
        }

        const response = await resetPassword(payload);

        if (!response.status) {
            throw response.error;
        }

        return response;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
